import {_addToEventLog, forceAppUpdate} from '../app/app'
import Config from '../launch/config'
import Effects from '../effects/effects'
import ArcTimer from '../arc-timer/arc-timer'
import Ship from '../ship/ship'
import Satellite from '../satellite/satellite'
import audio from '../launch/audio'

const handleBuildShipClick = (entity, isSatellite) => {
    if (!entity) {
        return
    }

    const {x, y} = entity
    const difficulty = Config.difficultyLevels[Config.difficulty]

    let resourceCost = difficulty.shipResourceCost
    let duration = difficulty.shipBuildTime
    let statusLabelText = 'Building'

    if (isSatellite) {
        resourceCost = difficulty.satelliteResourceCost
        duration = difficulty.satelliteBuildTime
        entity.isBuildingSatellite = true
        // statusLabelText = 'Building Satellite'
    }

    entity.statusLabel.setText(statusLabelText)
    entity.isBuildingShip = true

    Config.gameStats.resources -= resourceCost
    new Effects().resourceAnim({
        x,
        y,
        num: resourceCost,
        positive: false,
    })

    forceAppUpdate()

    const arc = new ArcTimer({
        color: Config.colorGreen,
        duration,
        radius: entity.diameter + 2,
        reverse: true,
        x,
        y,
    })

    arc.promise.then(() => {
        Config.gameStats.shipsBuilt += 1
        entity.isBuildingShip = false
        if (isSatellite) {
            entity.isBuildingSatellite = false
        }
        entity.statusLabel.setText('')

        const shipConfig = {
            faction: Config.userFactionName,
            orbitingEntity: entity,
            x,
            y,
        }

        const ship = isSatellite
            ? new Satellite(shipConfig)
            : new Ship(shipConfig)

        Config.ships[ship.id] = ship

        _addToEventLog({
            html: `<span style="color: #${Config.colorGreen}">${entity.name}</span> has built a ${ship.type}`,
            coords: {x, y},
        })
        audio.constructionComplete()
        forceAppUpdate()
    })
}

export default handleBuildShipClick
